export default "__VITE_ASSET__BFzvD6xv__"